import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';

type ProfileType = 'recruiter' | 'developer' | 'stalker' | 'adventure';

interface ContinueWatchingProps {
  profile: ProfileType;
}

const socialLinks = [
  { title: 'GitHub', icon: <FaGithub />, href: 'https://github.com/sarthakksingh', label: 'GitHub' },
  { title: 'LinkedIn', icon: <FaLinkedin />, href: 'https://www.linkedin.com/in/sarthak-singh-in', label: 'LinkedIn' },
  { title: 'Instagram', icon: <FaInstagram />, href: 'https://www.instagram.com/sarthaksxngh', label: 'Instagram' },
  { title: 'X', icon: <span aria-hidden="true">𝕏</span>, href: 'https://x.com/sarthaksxngh', label: 'X' },
];

const continueWatchingConfig = {
  recruiter: [
    { title: "Music", imgSrc: "https://i.pinimg.com/736x/c1/9a/96/c19a9667056d1c63cdb28697abb8de56.jpg", link: "/music" },
    { title: "Reading", imgSrc: "https://i.pinimg.com/736x/40/06/f1/4006f101bc334a4359eabf4ecddaca4e.jpg", link: "/reading" },
    { title: "Blogs", imgSrc: "https://i.pinimg.com/1200x/59/67/cc/5967cc48dc262fd706a6b3620632fe93.jpg", link: "/blogs" },
    { title: "Contact Me", imgSrc: "https://i.pinimg.com/736x/98/53/83/985383e8678545e9f478879709819c32.jpg", link: "/contact-me" }
  ],
  developer: [
    { title: "Music", imgSrc: "https://i.pinimg.com/736x/c1/9a/96/c19a9667056d1c63cdb28697abb8de56.jpg", link: "/music" },
    { title: "Reading", imgSrc: "https://i.pinimg.com/1200x/2c/7c/2c/2c7c2c09a61324c028b550ffb758f14e.jpg", link: "/reading" },
    { title: "Blogs", imgSrc: "https://i.pinimg.com/736x/48/6c/84/486c84575e4b3e8b9dc4f4e491880c5d.jpg", link: "/blogs" },
    { title: "Contact Me", imgSrc: "https://i.pinimg.com/736x/98/53/83/985383e8678545e9f478879709819c32.jpg", link: "/contact-me" }
  ],
  stalker: [
    { title: "Reading", imgSrc: "https://i.pinimg.com/1200x/2c/7c/2c/2c7c2c09a61324c028b550ffb758f14e.jpg", link: "/reading" },
    { title: "Blogs", imgSrc: "https://i.pinimg.com/736x/48/6c/84/486c84575e4b3e8b9dc4f4e491880c5d.jpg", link: "/blogs" },
    { title: "Music", imgSrc: "https://i.pinimg.com/736x/c1/9a/96/c19a9667056d1c63cdb28697abb8de56.jpg", link: "/music" },

  ],
  adventure: [
    { title: "Music", imgSrc: "https://i.pinimg.com/736x/c1/9a/96/c19a9667056d1c63cdb28697abb8de56.jpg", link: "/music" },
    { title: "Reading", imgSrc: "https://i.pinimg.com/1200x/2c/7c/2c/2c7c2c09a61324c028b550ffb758f14e.jpg", link: "/reading" }
  ]
};

const ContinueWatching: React.FC<ContinueWatchingProps> = ({ profile }) => {
  const continueWatching = continueWatchingConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">Continue Watching for {profile}</h2>
      <div className="card-row">
        {continueWatching.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>

      <h2 className="row-title social-title">Social Links</h2>
      <div className="social-grid">
        {socialLinks.map((social) => (
          <a
            key={social.title}
            href={social.href}
            className="social-card"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
          >
            <div className="social-icon">{social.icon}</div>
            <div className="social-text">
              <h3>{social.title}</h3>
              <p>Open profile</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatching;
